import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminApi } from "../../lib/api";
import { inputCls, labelCls } from "./shared";

export function SettingsTab() {
  const [form, setForm] = useState(null);
  useEffect(() => {
    adminApi().get("/settings/public".replace("/admin", "")).then((r) => setForm(r.data)).catch(() => {});
  }, []);
  if (!form) return <p className="text-slate-400 text-sm">Loading...</p>;
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  const save = async () => {
    try {
      await adminApi().put("/admin/settings", form);
      toast.success("Settings saved");
    } catch {
      toast.error("Save failed");
    }
  };
  return (
    <div className="bg-white border border-slate-200 rounded-lg p-6 max-w-xl space-y-4" data-testid="admin-settings-form">
      <div>
        <label className={labelCls}>Booking engine domain</label>
        <input data-testid="settings-booking-domain-input" className={inputCls} value={form.booking_domain || ""} onChange={set("booking_domain")} />
        <p className="text-xs text-slate-400 mt-1">Handoff URL base, e.g. https://sellvago.amadeusonlinesuite.com (search opens at {"{base}"}/flight/result?...)</p>
      </div>
      <div>
        <label className={labelCls}>WhatsApp number (intl format, no +)</label>
        <input data-testid="settings-whatsapp-input" className={inputCls} value={form.whatsapp_number || ""} onChange={set("whatsapp_number")} />
      </div>
      <div>
        <label className={labelCls}>Language code</label>
        <input data-testid="settings-langcode-input" className={inputCls} value={form.langcode || "EN"} onChange={set("langcode")} />
      </div>
      <div>
        <label className={labelCls}>Support phone (header top bar)</label>
        <input data-testid="settings-support-phone-input" className={inputCls} value={form.support_phone || ""} onChange={set("support_phone")} />
      </div>
      <div>
        <label className={labelCls}>Support email (header top bar)</label>
        <input data-testid="settings-support-email-input" className={inputCls} value={form.support_email || ""} onChange={set("support_email")} />
      </div>
      <div>
        <label className={labelCls}>Portal Sign In URL</label>
        <input data-testid="settings-signin-url-input" className={inputCls} value={form.portal_signin_url || ""} onChange={set("portal_signin_url")} />
      </div>
      <div>
        <label className={labelCls}>Portal Sign Up URL</label>
        <input data-testid="settings-signup-url-input" className={inputCls} value={form.portal_signup_url || ""} onChange={set("portal_signup_url")} />
      </div>
      <div>
        <label className={labelCls}>Google Analytics Measurement ID</label>
        <input data-testid="settings-ga-id-input" className={inputCls} value={form.ga_measurement_id || ""} onChange={set("ga_measurement_id")} placeholder="G-XXXXXXXXXX" />
        <p className="text-xs text-slate-400 mt-1">GA4 Measurement ID from Analytics → Admin → Data Streams. Leave empty to disable GA.</p>
      </div>
      <div>
        <label className={labelCls}>B2C promo banner text</label>
        <input data-testid="settings-banner-input" className={inputCls} value={form.b2c_banner_text || ""} onChange={set("b2c_banner_text")} />
      </div>
      <label className="flex items-center gap-2 text-sm font-semibold text-slate-700">
        <input type="checkbox" checked={!!form.b2c_banner_active} onChange={set("b2c_banner_active")} className="accent-[#970C10] w-4 h-4" data-testid="settings-banner-active-checkbox" />
        Banner active
      </label>
      <div className="border-t border-slate-100 pt-4">
        <p className="text-xs uppercase tracking-wide text-slate-500 font-bold mb-3">Offer rule engine (defaults for deal links & search)</p>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className={labelCls}>Depart days ahead</label>
            <input data-testid="settings-offer-days-input" type="number" min="0" className={inputCls} value={form.offer_days_ahead ?? 2} onChange={set("offer_days_ahead")} />
          </div>
          <div>
            <label className={labelCls}>Stay days (return)</label>
            <input data-testid="settings-offer-stay-input" type="number" min="1" className={inputCls} value={form.offer_stay_days ?? 7} onChange={set("offer_stay_days")} />
          </div>
          <div>
            <label className={labelCls}>Trip type</label>
            <select data-testid="settings-offer-triptype-select" className={inputCls} value={form.offer_trip_type || "roundtrip"} onChange={set("offer_trip_type")}>
              <option value="roundtrip">Round trip</option>
              <option value="oneway">One way</option>
            </select>
          </div>
          <div>
            <label className={labelCls}>Cabin class</label>
            <select data-testid="settings-offer-cabin-select" className={inputCls} value={form.offer_cabin || "Y"} onChange={set("offer_cabin")}>
              <option value="Y">Economy</option>
              <option value="W">Premium Economy</option>
              <option value="C">Business</option>
              <option value="F">First</option>
            </select>
          </div>
        </div>
        <p className="text-xs text-slate-400 mt-2">Airline pages can override these via &quot;offer rules override&quot; in the airline editor; individual destinations via a &quot;rules&quot; object in top destinations JSON.</p>
      </div>
      <button onClick={save} data-testid="settings-save-btn" className="bg-[#970C10] hover:bg-[#7A0A0D] text-white font-bold px-6 py-2.5 rounded-lg transition-colors duration-200">
        Save Settings
      </button>
    </div>
  );
}
